export const PHONE_DISPLAY = "717.691.1035";
export const PHONE_HREF = "tel:+17176911035";
export const EMAIL = "completemaintenanceservicesinc@gmail.com";
export const ADDRESS_LINE_1 = "3705 Trindle Road";
export const ADDRESS_LINE_2 = "Camp Hill, PA 17011";

export const TEAM = [
  { key: "jeff", name: "Jeff DeFrank", role: "President", phone: "(717) 554-8878", href: "tel:+17175548878" },
  { key: "dustin", name: "Dustin DeFrank", role: "Vice President", phone: "(717) 645-9719", href: "tel:+17176459719" },
  { key: "kathy", name: "Kathy Hecht", role: "Office Manager", phone: "(717) 691-1035", href: "tel:+17176911035" },
];

export const NAV_LINKS = [
  { id: "services", label: "Services" },
  { id: "industries", label: "Industries" },
  { id: "why", label: "Why CMS" },
  { id: "coverage", label: "Coverage" },
  { id: "partners", label: "Partner With Us" },
];

export const CLIENTS = [
  "L.B. Smith Ford",
  "Berkshire Hathaway",
  "Allen Distribution",
  "West Shore Y.M.C.A.",
  "Caliber Collision",
];

export const INDUSTRIES = [
  { name: "Auto Dealerships & Collision Centers", note: "Showrooms, service bays, customer lounges" },
  { name: "Corporate & Professional Offices", note: "Suites, lobbies, conference rooms, restrooms" },
  { name: "Warehouses & Distribution", note: "Dock areas, break rooms, high-traffic concrete" },
  { name: "Fitness & Community Centers", note: "Locker rooms, courts, lobbies, childcare spaces" },
  { name: "Industrial & Manufacturing", note: "Production floors, offices, shared facilities" },
];

export const PROCESS = [
  { n: "01", title: "Call us", text: "One call to 717.691.1035 starts the conversation. Tell us about your building and what it needs." },
  { n: "02", title: "Walk the site", text: "We look at your floors, traffic and schedule so the plan fits the facility you actually run." },
  { n: "03", title: "Set the scope", text: "A clear contract: what gets done, how often and when, priced for the scope you need." },
  { n: "04", title: "Keep it up", text: "Consistent crews and a reachable Camp Hill office, so standards hold month after month." },
];

export const CENTRAL_PA = [
  "Harrisburg", "Camp Hill", "Mechanicsburg", "Carlisle", "Hershey", "York",
  "Lancaster", "Lebanon", "Chambersburg", "Gettysburg", "State College", "Williamsport",
];

export const STATES = [
  { code: "NY", name: "New York", x: 50, y: 6 },
  { code: "NJ", name: "New Jersey", x: 92, y: 40 },
  { code: "DE", name: "Delaware", x: 86, y: 74 },
  { code: "MD", name: "Maryland", x: 56, y: 92 },
  { code: "WV", name: "West Virginia", x: 14, y: 80 },
  { code: "OH", name: "Ohio", x: 6, y: 38 },
];

export const PROVIDER_SERVICES = [
  "Janitorial / Contract Cleaning",
  "Floor Strip & Wax",
  "Burnishing",
  "Carpet Cleaning",
  "Window Cleaning",
  "Pressure Washing",
  "General Maintenance",
  "Industrial Cleaning",
];

export const AVAILABILITY = ["Nights", "Weekends", "Days", "On-call"];
